import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Vue.config.productionTip = false

Sentry.init({
  dsn: process.env.SENTRY_LARAVEL_DSN,
  integrations: [new VueIntegration({Vue, attachProps: true})],
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
